<label mat-dialog-title class="uk-text-title">{{ data.title }}</label>

<mat-dialog-content class="locations-picking">
  <mat-vertical-stepper #stepper [selectedIndex]="data.transactions.length - 1">
    <mat-step *ngFor="let item of controls; let i = index" [stepControl]="item" [editable]="false">
      <ng-template matStepLabel>{{ data.transactions[i] }}</ng-template>
    </mat-step>
  </mat-vertical-stepper>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
    id="exit"
    mat-flat-button
    class="button-primary-event border-box button-success m-2"
    [mat-dialog-close]="'ok'"
  >
    Salir
  </button>
</mat-dialog-actions>

<button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>